<template>
  <div class="mt-4 w-full">
    <div class="w-full h-[60%]">
      <div class="flex justify-center relative">
        <div class="relative flex justify-center">
          <img
            v-if="currentMedia"
            :src="usePreviewImg(currentMedia?.url)"
            class="w-[80%] aspect-[3/4]"
            alt=""
            @load="emit('update:imgLoaded', true)"
            crossorigin="anonymous"
          />
          <div
            v-if="isGenerating || !imgLoaded"
            class="bg-[rgba(0,0,0,0.5)] absolute top-0 left-0 right-0 bottom-0"
          />
        </div>

        <div
          class="absolute top-[50%] left-[50%] translate-[-50%]"
          v-if="isGenerating || !imgLoaded"
        >
          <VanLoading type="spinner" color="#fff" size="20px" />
        </div>
      </div>
    </div>
    <div
      v-if="mediaList && mediaList.length > 0"
      class="flex overflow-x-auto mt-1"
    >
      <img
        v-for="item in mediaList"
        @click="clickSwitchImage(item)"
        :class="[
          'w-20 border',
          item.id === currentMedia?.id
            ? 'border-primary'
            : 'border-transparent',
        ]"
        :src="usePreviewImg(item.url!)"
        crossorigin="anonymous"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { usePreviewImg } from "@/use/common";
import { PropType } from "vue";

defineProps({
  mediaList: {
    type: Array as PropType<Array<any>>,
  },
  currentMedia: {
    type: Object as PropType<any>,
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
  imgLoaded: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:currentMedia", "update:imgLoaded"]);

const clickSwitchImage = (item: any) => {
  emit("update:currentMedia", item);
};
</script>
